<script>
  import { Tooltip, Button } from "paxray-components-svelte";

  export let applications = [];
  export let getIconUrl;
  export let formatDuration;
  export let formatNumber;

  $: applicationNameWidth = `${Math.min(
    12,
    Math.max(
      7,
      Math.max(
        ...applications.map(
          (application) => String(application.application || "N/A").length,
        ),
        0,
      ) * 0.48,
    ),
  )}rem`;

  function formatShare(value) {
    if (value === null || value === undefined || Number.isNaN(Number(value)))
      return "N/A";
    return `${Math.round(Number(value))}%`;
  }

  function handleIconError(event) {
    event.currentTarget.classList.add("app-icon-hidden");
    event.currentTarget.nextElementSibling?.classList.remove(
      "app-icon-fallback-hidden",
    );
  }
</script>

<section class="portfolio-card">
  <div class="card-heading">
    <div>
      <div class="heading-title">
        <strong>Leading Applications</strong><Tooltip
          text="Shows the ten applications with the highest share of observed active time. Top 10 by active-time share."
        />
      </div>
    </div>
    <!-- <Button text="Open catalog" kind="secondary" on:click={onOpenCatalog} /> -->
  </div>
  <div
    class="application-bars"
    style={`--application-name-width: ${applicationNameWidth};`}
  >
    {#each applications as application, index}
      <div
        class:last-row={index === applications.length - 1}
        class="application-bar-row"
      >
        <div class="application-icon" aria-hidden="true">
          <img
            src={getIconUrl(application)}
            alt=""
            on:error={handleIconError}
          />
          <span class="app-icon-fallback app-icon-fallback-hidden"
            >{application.application?.slice(0, 1).toUpperCase() || "?"}</span
          >
        </div>
        <strong class="application-label" title={application.application}
          >{application.application || "N/A"}</strong
        >
        <div class="application-bar-track">
          <span
            style={`width: ${application.share ? Math.max(2, application.share) : 0}%`}
          />
        </div>
        <span class="application-share">
          {formatShare(application.share)}
          <Tooltip
            text={application.tooltip ||
              `${formatDuration(application.active_time_seconds)} active time · ${formatNumber(application.users)} users`}
          />
        </span>
      </div>
    {/each}
  </div>
</section>

<style>
  .portfolio-card {
    display: flex;
    min-width: 0;
    overflow: hidden;
    flex-direction: column;
    border: 0;
    border-radius: 0.5rem;
    background: #fff;
    padding: 0 1rem 1rem;
  }
  .card-heading {
    display: flex;
    height: 4rem;
    min-height: 4rem;
    box-sizing: border-box;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
  }
  .card-heading > div {
    display: flex;
    min-width: 0;
    flex-direction: column;
    gap: 0.15rem;
  }
  .heading-title {
    display: flex !important;
    flex-direction: row !important;
    align-items: center;
    gap: 0.45rem;
  }
  .card-heading {
    box-sizing: border-box;
    margin-right: -1rem;
    margin-bottom: 1rem;
    margin-left: -1rem;
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .card-heading strong {
    font-size: 0.875rem;
  }
  .application-bars {
    display: grid;
    min-height: 0;
    flex: 1;
    grid-auto-rows: minmax(clamp(2rem, 3vh, 2.4rem), 1fr);
    gap: 0;
    margin-top: 1rem;
  }
  .application-bar-row {
    display: grid;
    grid-template-columns: 1.6rem var(--application-name-width) minmax(
        5rem,
        1fr
      ) 4rem;
    align-items: center;
    gap: 0.6rem;
    padding: 0.42rem 0;
    border-bottom: 1px solid #e6e8eb;
  }
  .application-bar-row.last-row {
    border-bottom: 0;
  }
  .application-icon {
    position: relative;
    display: grid;
    width: 1.6rem;
    height: 1.6rem;
    place-items: center;
    overflow: hidden;
  }
  .application-icon img,
  .app-icon-fallback {
    width: 1.6rem;
    height: 1.6rem;
    border-radius: 0.3rem;
    object-fit: contain;
  }
  .app-icon-fallback {
    display: grid;
    place-items: center;
    background: transparent;
    color: transparent;
    font-size: 0.78rem;
    font-weight: 400;
  }
  .app-icon-fallback-hidden,
  .application-icon :global(.app-icon-hidden) {
    display: none;
  }
  .application-label {
    min-width: 0;
    overflow: hidden;
    font-size: 0.78rem;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .application-bar-track {
    height: 0.42rem;
    overflow: hidden;
    border-radius: 99px;
    background: #eeeeee;
  }
  .application-bar-track span {
    display: block;
    height: 100%;
    border-radius: inherit;
    background: var(--pax-orange);
  }
  .application-share {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.25rem;
    padding-left: 0.1rem;
    font-size: 0.78rem;
    text-align: right;
  }

  @media (max-width: 1100px) {
    .application-bar-row {
      grid-template-columns: 1.6rem var(--application-name-width) minmax(
          4rem,
          1fr
        ) 4rem;
    }
  }
</style>
